export default __webpack_public_path__ + "fonts/iconfont.a8ff4c8845951f0e663e297e3ab645d3.svg";